var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "totals-box mb-2" }, [
    _c(
      "div",
      { staticClass: "totals-info-wrapper col" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: { path: "/jobs/edit/" + _vm.discount.job_id },
              target: "_blank"
            }
          },
          [
            _c("div", { staticClass: "total-ref-id pointer" }, [
              _vm._v(_vm._s(_vm.discount.ref_id))
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.discount.move_date) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.discount.company) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.discount.carrier) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.discount.name) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c(
        "div",
        { staticClass: "total-info-numbers" },
        [
          _vm.discount.discount_unit_type_id === 1
            ? [_vm._v("\n        $" + _vm._s(_vm.discount.amount) + "\n      ")]
            : _vm.discount.discount_unit_type_id === 2
              ? [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.discount.amount) +
                      " (" +
                      _vm._s(_vm.discount.amount_percent) +
                      "%)\n      "
                  )
                ]
              : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.discount.type) + "\n      "),
        _vm.$_can("job-discounts.change-type")
          ? _c("div", { staticClass: "pointer menu w-25 text-center" }, [
              _vm.discount.is_editable
                ? _c(
                    "div",
                    {
                      attrs: {
                        id: "dropdownMenuButtonEditDiscountType",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-ellipsis-h text-secondary menu-icon",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.discount.is_editable
                ? _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      attrs: {
                        "aria-labelledby": "dropdownMenuButtonEditDiscountType"
                      }
                    },
                    _vm._l(_vm.discountTypes, function(discountType) {
                      return _c(
                        "a",
                        {
                          key: discountType.id,
                          staticClass: "dropdown-item p-1 small",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              _vm.changeType(
                                _vm.discount.discount_id,
                                discountType.id
                              )
                            }
                          }
                        },
                        [_vm._v("\n            " + _vm._s(discountType.name))]
                      )
                    })
                  )
                : _vm._e()
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c248714a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c248714a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/DiscountsBlock.vue
// module id = null
// module chunks = 